import './RouletteLotAttach.sass';

import React, { FC } from 'react';

import { RouletteLotAttachProps } from './RouletteLotAttach.interface';
import { IcWheel28 } from '$assets';
import { Currency } from '$shared/components';
import { CurrencyEnum } from '$store/models';

import { classNames as cn } from '$utils';
import { showModal } from '$navigation/helper';

export const RouletteLotAttach: FC<RouletteLotAttachProps> = ({ price, rouletteLot }) => {
  return (
    <div
      className={cn('RouletteLotAttach', rouletteLot.color, {
        active: rouletteLot.postId,
      })}
      onClick={() => {
        rouletteLot.postId && showModal(`post${rouletteLot.postId}`);
      }}
    >
      <div className="RouletteLotAttach__info">
        <div className="RouletteLotAttach__info__title">{rouletteLot.title}</div>
        <div className="RouletteLotAttach__info__price">
          <Currency amount={price || 0} currency={CurrencyEnum.EUR} />
        </div>
      </div>
      <div className="RouletteLotAttach__icon">
        <IcWheel28 />
      </div>
    </div>
  );
};
